import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import UnarchiveIcon from 'assets/unarchive.svg';

const UnarchiveButton = ({ isOnHover, onUnarchive }) => (
  <div className={`shrink-0 ${isOnHover ? 'visible' : 'invisible'}`}>
    <Tooltip color="#232630" title="Unarchive">
      <button
        data-testid="unarchive-button"
        className="flex h-8 w-8 shrink-0 items-center justify-center focus:outline-hidden"
        type="button"
        onClick={onUnarchive}
      >
        <img
          className="block h-[18px] w-[18px] shrink-0"
          src={UnarchiveIcon}
          alt="unarchive"
        />
      </button>
    </Tooltip>
  </div>
);

UnarchiveButton.propTypes = {
  isOnHover: PropTypes.bool.isRequired,
  onUnarchive: PropTypes.func.isRequired
};

export default UnarchiveButton;
